export const clampButtonText = (copy: string): string =>
  copy.length > 25 ? copy.substring(0, 22) + '…' : copy;
